export { default } from "./SlimHero";
